// extracted by mini-css-extract-plugin
export default {"header":"MerchantPage_header__9tId6","title":"MerchantPage_title__r8hg1","title_wrapper":"MerchantPage_title_wrapper__84Vsm","content":"MerchantPage_content__s3xdL"};